<div class="wrapper__headerComponent container my-5">
    <div class="row align-items-center">
      <div class="col-12 col-md-3"></div>
      <div class="col-12 col-md-6">
        <h2 class="text-center h3-tipografia-govco mb-0">
          {{"gestion-expediente-administrador" | translate}}
        </h2>
      </div>
    </div>
  </div>
  <div class="wrapper__contentComponent--expediente container my-5">
    <div class="d-flex flex-row justify-content-end mb-5">
      <div style="margin-right: 1rem;">
        <button
          id="enviarSegundaInstancia"
          [disabled]="disabledEnviarASegundaInstancia"
          (click)="enviarSegundaInstancia()"
          class="btn-govco outline-btn-govco hvr-shrink"
          aria-label="Enviar a segunda instancia"
          ><span class="govco-plus-square-1"></span>
          {{"enviar-segunda-instancia" | translate}}
        </button>
      </div>
      <div>
        <button
          *ngIf="true"
          id="crearEntidadSegundaInstancia"
          class="btn-govco outline-btn-govco hvr-shrink"
          [style.visibility]="true"
          (click)="agregarEntidadSegundaInstancia()"
          aria-label="Crear entidad segunda instancia">
          {{"crear-entidad-segunda-instancia" | translate}}
        </button>
      </div>
    </div>
    <div class="contenedor-tabla w-100" *ngIf="actualizarGuardadoEntidad">
        <app-table
        id="historico"
        (evento)="buscar($event)"
        [datos]="expedientes"
        [acciones]="acciones"
        [paginaActual]="paginaActual"
        [multipleSelection]="true"
        (selectedItemsChange)="handleSelectedItems($event)"
        (eventoAccion)="accionSelectSegundaInstancia($event)"
        [columnas]="columns"
        [paginacion]="true"
        [idColumn]="'Id'"
        [tamano]="tamanoPagina"
        [totalPaginas]="totalPaginas"
        [tamanos]="[1, 5, 10, 20]"></app-table>
    </div>
    <div class="d-flex flex-row justify-content-end mb-5 mt-5">

    </div>
  </div>
  <app-politica-tratamiento-datos-personales></app-politica-tratamiento-datos-personales>

  <div *ngIf="openModalAgregarSegundaInstancia">
    <app-modal-agregar-entidad-segunda-instancia (guardadoEntidad)="guardadoEntidad($event)"></app-modal-agregar-entidad-segunda-instancia>
  </div>
